// extracted by mini-css-extract-plugin
export default {"title":"WeatherPage_title__rr8gO"};